import { marketersOfferBanner as content } from '~/content/marketers';
import { Icon } from '~/components/ui';
import { cn } from '~/lib/cn';

const learnMoreClasses = 'cursor-pointer text-red-500 hover:text-red-700';

/**
 * Cashback offer strip under the marketer hero (Figma 1272:49185). "Learn more"
 * opens the offer popup (MarketersOfferModal, mounted at page level); on mobile
 * it sits inline at the end of the copy.
 */
export function MarketersOfferBanner({
  onLearnMore,
  className,
}: {
  onLearnMore: () => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-6 border-y border-grey-100 py-6 md:h-16 md:gap-[23px] md:py-0 md:ps-5 md:pe-1',
        className,
      )}>
      <Icon name="star" className="size-6 shrink-0" />
      <p className="flex-1 text-[12px] leading-[1.32] tracking-[-0.024px] text-grey-900 md:text-body md:text-black">
        {content.text}{' '}
        <button
          type="button"
          aria-haspopup="dialog"
          onClick={onLearnMore}
          className={cn(learnMoreClasses, 'md:hidden')}>
          {content.learnMore}.
        </button>
      </p>
      <button
        type="button"
        aria-haspopup="dialog"
        onClick={onLearnMore}
        className={cn(learnMoreClasses, 'hidden shrink-0 text-body md:block')}>
        {content.learnMore}
      </button>
    </div>
  );
}
